<template>
  <div class="container" v-loading="loading1">
    <van-form ref="form" class="form">
      <!-- 长者姓名 -->
      <van-field name="checkbox" label="长者姓名">
        <template #input>
          <el-select v-model="form.Regid" placeholder="请选择" size="small">
            <el-option v-for="item in options1" :key="item.Regid" :label="item.Name" :value="item.Regid"> </el-option>
          </el-select>
        </template>
      </van-field>

      <!-- 暂离院事由 -->
      <van-field name="checkbox" label="暂离院事由">
        <template #input>
          <el-select v-model="form.Typeid" placeholder="请选择" size="small">
            <el-option v-for="item in options2" :key="item.Id" :label="item.Name" :value="item.Id"> </el-option>
          </el-select>
        </template>
      </van-field>

      <!-- 离院时间 -->
      <van-field name="checkbox" label="离院时间">
        <template #input>
          <el-date-picker type="datetime" size="small" placeholder="选择日期" v-model="form.BeginDate" style="width: 100%" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"></el-date-picker>
        </template>
      </van-field>

      <!-- 回院时间 -->
      <van-field name="checkbox" label="回院时间">
        <template #input>
          <el-date-picker type="datetime" size="small" placeholder="选择日期" v-model="form.EndDate" style="width: 100%" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"></el-date-picker>
        </template>
      </van-field>

      <!-- 家属信息 -->
      <van-field v-model="form.ContactPerson" name="家属信息" label="家属信息" placeholder="请输入" />

      <!-- 备注 -->
      <van-field v-model="form.Remark" name="备注" label="备注" placeholder="请输入" />
    </van-form>

    <div class="btn" v-loading="loading1" @click="onSubmit">{{ flag ? '添加' : '修改' }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {},
      loading1: false,
      flag: true,
      options1: [],
      options2: []
    }
  },
  created() {
    if (Object.keys(this.$route.params).length) {
      this.form = { ...this.$route.params }
      this.flag = false
    }
    this.getUserList()
    this.getListType()
  },
  methods: {
    // 获取长者
    getUserList() {
      this.$axios.post('/pad/Absentee').then((res) => {
        this.options1 = res.data.obj
      })
    },

    // 获取离院事由
    getListType() {
      this.$axios.get('/Community/GetCodeListType?type=49').then((res) => {
        this.options2 = res.data.obj
      })
    },
    // 提交
    onSubmit() {
      let message = null
      if (!this.form.BeginDate) message = '请选择离院时间'
      if (!this.form.Typeid) message = '请选择离院事由'
      if (!this.form.Regid) message = '请选择长者'
      if (message) {
        return this.$message.error({
          message,
          offset: 100
        })
      }

      this.loading1 = true
      const url = this.flag ? '/pad/TemporaryAdded' : '/pad/TemporaryEdit'
      this.$axios.post(url, { ...this.form, Creator: this.$store.state.user.UserName }).then(
        (res) => {
          this.loading1 = false
          this.$message.success({
            message: this.flag ? '新增成功' : '修改成功',
            offset: 100
          })
          this.$router.go(-1)
        },
        () => {
          this.loading1 = false
        }
      )
    }
  }
}
</script>

<style scoped>
.container {
  padding: 12px 12px;
}
.w220 {
  width: 220px;
}

.form {
  background: #fff;
}

.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  border-radius: 4px;
  margin-top: 14px;
  background: #029fd1;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/leave/add.vue